import { SESSION_STORAGE } from '../utils/sessionStorageConstants';

export const setUtmSource = (productUUID: string, utm: string) => {
  if (!utm) {
    utm = document.referrer;
  }
  localStorage.setItem(SESSION_STORAGE.UTM_SOURCE + productUUID, utm);
};

export const getUtmSource = (productUUID: string) => {
  let utm = sessionStorage.getItem(SESSION_STORAGE.UTM_SOURCE);
  if (!utm) {
    utm = localStorage.getItem(SESSION_STORAGE.UTM_SOURCE + productUUID);
  }

  return utm;
};

export function setInStoreParams(productUUID: string) {
  const storeNumber = sessionStorage.getItem(SESSION_STORAGE.STORE_NUMBER);
  if (storeNumber) {
    localStorage.setItem(
      SESSION_STORAGE.STORE_NUMBER + productUUID,
      storeNumber
    );
  }
  const employeeId = sessionStorage.getItem(SESSION_STORAGE.EMPLOYEE_ID);
  if (employeeId) {
    localStorage.setItem(SESSION_STORAGE.EMPLOYEE_ID + productUUID, employeeId);
  }
}

export function getStoreNumber(productUUID: string) {
  return (
    sessionStorage.getItem(SESSION_STORAGE.STORE_NUMBER) ??
    localStorage.getItem(SESSION_STORAGE.STORE_NUMBER + productUUID)
  );
}

export function getEmployeeId(productUUID: string) {
  return (
    sessionStorage.getItem(SESSION_STORAGE.EMPLOYEE_ID) ??
    localStorage.getItem(SESSION_STORAGE.EMPLOYEE_ID + productUUID)
  );
}
